export default __webpack_public_path__ + "static/media/NotoSansArabic-arabic.3f3bb83c.woff2";